import { render, staticRenderFns } from "./UserBillingAddresses.vue?vue&type=template&id=6929faa0&scoped=true&"
import script from "./UserBillingAddresses.vue?vue&type=script&lang=ts&"
export * from "./UserBillingAddresses.vue?vue&type=script&lang=ts&"
import style0 from "./UserBillingAddresses.vue?vue&type=style&index=0&id=6929faa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929faa0",
  null
  
)

export default component.exports